import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const FAQS = [
  {
    q: "Who can apply?",
    a: "Final-year students and recent graduates aged 20–28 who live or study in Osun State, Nigeria. Eligibility will be checked.",
  },
  {
    q: "Is this a lecture or a training course?",
    a: "It is a one-day practical strategy lab. You will work in teams on case simulations, make decisions and present recommendations. It is not an accredited qualification.",
  },
  {
    q: "Will selected delegates pay to attend?",
    a: "The intention is to sponsor selected delegates. The final coverage of meals, materials and travel support will be stated in the admission notice once funding is confirmed.",
  },
  {
    q: "When and where will it hold?",
    a: "Saturday, 30 January 2027, 10:00 AM–4:00 PM at Aurora Conference Centre, Osogbo, Osun State.",
  },
  {
    q: "Does applying guarantee a seat?",
    a: "No. Applications will be reviewed against the eligibility and selection criteria. Only selected applicants will receive admission confirmation.",
  },
];

export default function Faq() {
  return (
    <section>
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">Quick answers</div>
          <h2 className="title">Before you apply.</h2>
          <ThemeTag />
        </Reveal>
        <div style={{ maxWidth: "800px" }}>
          {FAQS.map((faq, i) => (
            <Reveal key={faq.q} delay={i * 0.05}>
              <details data-testid="faq-accordion-item">
                <summary>{faq.q}</summary>
                <p>{faq.a}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
